import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "98",
  height: "94",
  viewBox: "0 0 98 94",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon-curved-arrow-right"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'IconCurvedArrowRight',
  props: {
  styleInternal: {
    type: String,
    required: false,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M97.2071 85.2929C97.5976 85.6834 97.5976 86.3166 97.2071 86.7071L90.8431 93.0711C90.4526 93.4616 89.8195 93.4616 89.4289 93.0711C89.0384 92.6805 89.0384 92.0474 89.4289 91.6569L95.0858 86L89.4289 80.3431C89.0384 79.9526 89.0384 79.3195 89.4289 78.9289C89.8195 78.5384 90.4526 78.5384 90.8431 78.9289L97.2071 85.2929ZM96.5 87C63.4976 87 39.4337 81.8947 23.6361 68.3457C7.79843 54.7622 0.5 32.9017 0.5 1.19249e-08L2.5 -1.19249e-08C2.5 32.6626 9.75112 53.8021 24.9382 66.8276C40.1654 79.8874 63.6016 85 96.5 85L96.5 87Z",
      fill: "white",
      style: _normalizeStyle(__props.styleInternal)
    }, null, 4)
  ]))
}
}

})